import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation batchUpdateVirtualPublishRule($contents: [UpdatePublishRuleInput],  $parentAssetId: ID $project: String $module: String!) {
      batchUpdateVirtualPublishRule(
          input: $contents, 
          parentAssetId: $parentAssetId
          project: $project
          module: $module
        ) {
            id
            assetId
            group{
              id
            }
            isEnabled
            publishEndDate
            publishStartDate
          }
    }`
)
